export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID, 
        authority: process.env.REACT_APP_AZURE_AUTHORITY, 
        redirectUri: process.env.NODE_ENV === 'development' 
            ? "http://localhost:3000" 
            : process.env.REACT_APP_AZURE_REDIRECT_URI, 
           
    },
    cache: {
        cacheLocation: "localStorage", 
        storeAuthStateInCookie: false, 
    },
};
export const powerBiScope = ["https://analysis.windows.net/powerbi/api/.default"];